import { useQuery } from 'react-query';
import apiClient from '../api/client';

interface User {
  id: string;
  username: string;
  firstName: string;
  lastName: string;
  role: string;
  organizationId: string;
}

interface AuthData {
  user: User;
  token: string;
}

export const useAuth = () => {
  const token = localStorage.getItem('token');
  
  const { data: authData, isLoading, error } = useQuery<AuthData>(
    ['auth', token],
    async () => {
      if (!token) {
        throw new Error('No token');
      }
      
      // Декодируем JWT токен для получения базовой информации
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return {
          user: {
            id: payload.sub || payload.userId,
            username: payload.username,
            firstName: payload.firstName || '',
            lastName: payload.lastName || '',
            role: payload.role,
            organizationId: payload.organizationId
          },
          token
        };
      } catch (e) {
        throw new Error('Invalid token');
      }
    },
    {
      enabled: !!token,
      staleTime: 5 * 60 * 1000, // 5 минут
      retry: false
    }
  );

  const isAuthenticated = !!token && !!authData;
  const user = authData?.user;
  const isSuperAdmin = user?.role === 'super_admin';
  const isAdmin = user?.role === 'admin';
  const isOperator = user?.role === 'operator';

  const logout = () => {
    localStorage.removeItem('token');
    window.location.href = '/login';
  };

  return {
    user,
    isAuthenticated,
    isSuperAdmin,
    isAdmin,
    isOperator,
    isLoading,
    error,
    logout
  };
};
